import type { StytchB2BUIClient } from "@stytch/vanilla-js/b2b";

/**
 * Create the empty Stytch client that the iOS provider needs.
 * Native iOS authentication uses the Swift bridge and bearer sessions.
 */
export function createNativeStytchClient(): StytchB2BUIClient {
    const stub = {
        self: { getInfo: () => ({ member: null, fromCache: false }) },
        session: {
            getInfo: () => ({ session: null, fromCache: false }),
            revoke: () => undefined,
        },
        organization: { getInfo: () => ({ organization: null, fromCache: false }) },
        onStateChange: () => () => undefined,
    };
    return stub as unknown as StytchB2BUIClient;
}
